import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import styles from './Input.module.css';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    rightAddon?: React.ReactNode;  // Elemento a la derecha del input
    showPasswordToggle?: boolean;  // Toggle automático para password
    noMargin?: boolean;             // Sin margin-bottom
}

export const Input = ({
    label,
    error,
    rightAddon,
    showPasswordToggle = false,
    noMargin = false,
    className = '',
    type,
    ...props
}: InputProps) => {
    const [showPassword, setShowPassword] = useState(false);

    // Si es password y tiene toggle, controlar el tipo internamente
    const inputType = (type === 'password' && showPasswordToggle)
        ? (showPassword ? 'text' : 'password')
        : type;

    // Si showPasswordToggle está activo, crear el botón de toggle
    const passwordToggleButton = showPasswordToggle && type === 'password' ? (
        <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className={styles['password-toggle']}
            title={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
            aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
    ) : null;

    // El rightAddon final es el toggle de password o el rightAddon custom
    const finalRightAddon = passwordToggleButton || rightAddon;

    return (
        <div className={`${styles['input-field']} ${error ? styles['input-field-error'] : ''} ${noMargin ? styles['no-margin'] : ''}`}>
            {label && <label htmlFor={props.id}>{label}</label>}

            {finalRightAddon ? (
                <div className={styles['input-wrapper']}>
                    <input
                        type={inputType}
                        className={className}
                        {...props}
                    />
                    {finalRightAddon}
                </div>
            ) : (
                <input
                    type={inputType}
                    className={className}
                    {...props}
                />
            )}

            {error && <span className={styles['input-field-error-message']}>{error}</span>}
        </div>
    );
};
